import axiosClient from 'api/axiosClient';
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSDropdown, { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import CustomDateRangePicker, { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ViewAddInvestmentPackage from '../ViewAddInvestmentPackage';
import ViewRegisterInvestmentPackage from '../ViewRegisterInvestmentPackage';
import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import ButtonFilterDropdown from 'general/components/quybka/Buttons/ButtonFilterDropdown';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import AppRoute from 'general/constants/AppRoute';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import AppResource from 'general/constants/AppResource';

const defaultColumnIds = [
  'ORDER_CODE',
  'AGENCY_ID',
  'ORDER_TYPE',
  'AMOUNT',
  'STATUS',
  'STATUS_CONTRACT',
  'CONTRACT_NUMBER',
  'USER_ID',
  'TIME',
  'COMPLETED_DATE'
];

function PackageTransactionView(props) {
  // MARK: ---- params ----
  const { t } = useTranslation();
  const router = useRouter();
  const {
    adminRole,
    agencyDetail,
    packageTransactionList,
    packageTransactionTotal,
    filter,
    onFilterChanged,
    agencyId,
    showFullUI = false,
    handleAddOrder,
  } = props;
  const { user, agencyRoleList } = useSelector((state) => state.auth);
  const userAgencyId = user?.agency?.agencyId;
  const isMine = userAgencyId == agencyId;
  const [filterDropdown, setFilterDropdown] = useState(filter);

  const fullColumns = useMemo(() => {
    return [
      {
        id: 'ORDER_CODE',
        name: UIHelper.buildTableColumn('Mã đơn hàng'),
        selector: (row) => row?.saleCode ?? row?.saleId,
        width: '140px',
        style: tableStyle.columns.link,
      },
      {
        id: 'AGENCY_ID',
        name: UIHelper.buildTableColumn('Người bán hàng/giới thiệu'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              AgencyHelper.Navigation.navigateToAgencyDetail(null, row?.agency);
            }}
          >
            {row?.agency?.name}
          </span>
        ),
        minWidth: '240px',
        style: tableStyle.columns.link,
      },
      {
        id: 'ORDER_TYPE',
        name: UIHelper.buildTableColumn('Loại đơn hàng'),
        selector: (row) => AgencyHelper.Utils.getSaleOrderTypeName(row?.orderType),
        width: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'AMOUNT',
        name: UIHelper.buildTableColumn('Tổng tiền', 'VNĐ'),
        selector: (row) => row?.orderType !== 'LANDLORD' ? Utils.formatNumber(row?.amount ?? 0) : '',
        right: true,
        width: '140px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'STATUS',
        name: UIHelper.buildTableColumn('Trạng thái đơn hàng'),
        selector: (row) => (
          <KTLabel
            text={AgencyHelper.Utils.getSaleOrderStatusName(row?.status, row?.orderType)}
            isInline={true}
            size={KTLabelSize.medium}
            additionalClassName={`label-light-${AgencyHelper.Utils.getSaleOrderStatusColor(
              row?.status
            )}`}
          />
        ),
        minWidth: '200px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'STATUS_CONTRACT',
        name: UIHelper.buildTableColumn('Trạng thái hợp đồng'),
        selector: (row) => {
          return !!_.first(row?.contracts) ? (
            <KTLabel
              text={AgencyHelper.Utils.getContractStatusName(_.first(row?.contracts)?.status)}
              isInline={true}
              size={KTLabelSize.medium}
              additionalClassName={`label-light-${AgencyHelper.Utils.getContractStatusColor(
                _.first(row?.contracts)?.status
              )}`}
              additionalDescription={_.first(row?.contracts)?.cancelingReason}
            />
          ) : (
            <></>
          );
        },
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'CONTRACT_NUMBER',
        name: UIHelper.buildTableColumn('Số hợp đồng'),
        selector: (row) => row?.contractNumber,
        width: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'USER_ID',
        name: UIHelper.buildTableColumn('Người tạo đơn'),
        selector: (row) => (
          <span className="cursor-pointer hover-opacity-60" onClick={() => { }}>
            {row?.user?.fullname}
          </span>
        ),
        minWidth: '240px',
        style: tableStyle.columns.link,
      },
      {
        id: 'TIME',
        name: UIHelper.buildTableColumn('Ngày tạo'),
        selector: (row) => Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm'),
        width: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'COMPLETED_DATE',
        name: UIHelper.buildTableColumn('Ngày hoàn thành'),
        selector: (row) => Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY - HH:mm'),
        width: '160px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        maxWidth: '140px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        center: false,
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
        },
      },
    ];
  }, []);

  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = `${router.pathname}${router.location.hash}`;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns.filter(column => !column.omit).map(column => column.id).filter(Boolean) || []
  );
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
    saveChanges,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

  const handleFilterChanged = (filter) => {
    if (onFilterChanged) {
      onFilterChanged(filter);
    }
  };

  // MARK: ---- methods ----

  const getStatusColor = (status) => {
    switch (status) {
      case 'PENDING':
        return 'warning';
      case 'COMPLETED':
        return 'success';
      case 'WITHDRAWED':
        return 'primary';
      case 'TRANSFERED':
        return 'primary';
      default:
        return 'primary';
    }
  };

  const FilterComponentList = ({ isInDropdown = false }) => (
    <div className={`${isInDropdown ? 'row' : 'w-100'} d-flex  flex-row  flex-wrap`}>
      {/* trang thai don hang */}
      <KTDropdownFilter
        label={t('status')}
        filterKey="status"
        options={[
          { name: 'Tất cả', value: '' },
          ...AgencyHelper.Data.orderStatusOptions,
        ]}
        selectedValue={
          !isInDropdown
            ? filter.status
            : filterDropdown.status
        }
        isInDropdown={isInDropdown}
        additionalClassName={`${isInDropdown ? 'pr-2 pt-4' : 'pl-0 pr-4'}`}
        handleChange={(value) => {
          if (isInDropdown) {
            setFilterDropdown({
              ...filterDropdown,
              status: value,
            });
          } else {
            handleFilterChanged({
              status: value,
              page: 0,
            });
          }
        }}
        direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
      />

      {/* trang thai hop dong */}
      <KTDropdownFilter
        label={t('Trạng thái hợp đồng')}
        filterKey="contractStatus"
        options={[
          { name: 'Tất cả', value: '' },
          ...AgencyHelper.Data.contractOptions,
        ]}
        selectedValue={
          !isInDropdown
            ? filter.contractStatus
            : filterDropdown.contractStatus
        }
        isInDropdown={isInDropdown}
        additionalClassName={`${isInDropdown ? 'pl-2 pt-4' : 'pl-0 pr-4'}`}
        handleChange={(value) => {
          if (isInDropdown) {
            setFilterDropdown({
              ...filterDropdown,
              contractStatus: value,
            });
          } else {
            handleFilterChanged({
              contractStatus: value,
              page: 0,
            });
          }
        }}
        direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
      />

      {isInDropdown && (
        <>
          <div className="col-12 py-2">
            <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
              {t('Khoảng thời gian thống kê')}
            </label>
            <CustomDateRangePicker
              toggleElementBorderRadius={5}
              alignRight={true}
              initialValue={
                filterDropdown.selectedValue.length > 0
                  ? filterDropdown.selectedValue
                  : dateFilter.tatCaThoiGian
              }
              onPressSave={(selectedValue, startDate, endDate) => {
                const updateFilterDropdown = {
                  ...filterDropdown,
                  from: startDate,
                  to: endDate,
                  selectedValue: selectedValue,
                };
                setFilterDropdown(updateFilterDropdown);
              }}
              filterComponent={filterDropdown}
              direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
            />
          </div>
        </>
      )}
    </div>
  );

  const buildMoreActions = (row) => {
    const contract = _.first(row?.contracts);
    const actions = [];
    // xem chi tiet
    actions.push({
      text: 'Xem chi tiết',
      iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
      click: () => {
        Utils.openInNewTab(`${AppRoute.orderList}/${row?.saleId}`)
      },
    });
    if (adminRole) {
      actions.push({
        text: 'Chỉnh sửa',
        iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          Utils.openInNewTab(`${AppRoute.orderList}/${row?.saleId}/edit`);
        },
      });

      actions.push({
        text: 'Hủy đơn hàng',
        iconElement: (
          <i
            className="fa-regular fa-times-circle"
            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
          />
        ),
        click: () => {
          AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
              iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
              title="Hủy đơn hàng"
              contentEl={
                <>
                  Bạn có chắc muốn hủy đơn hàng:{' '}
                  <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                    {row?.saleId}
                  </span>
                  ?
                </>
              }
              onCancel={() => {
                AppCustomDialogHelper.hide();
              }}
              onConfirm={async () => {
                // const uncancelledContract = row?.contracts?.find(contract => contract?.status !== AgencyConstants.ContractStatus.CANCELLED);
                // if (!!uncancelledContract) {
                //   if (uncancelledContract?.status === AgencyConstants.ContractStatus.EXPIRED) {
                //     ToastHelper.showError(`Không thể hủy đơn hàng vì tồn tại hợp đồng ${uncancelledContract?.contractNumber} đã hết hạn`)
                //   } else {
                //     ToastHelper.showError(`Không thể hủy đơn hàng vì tồn tại hợp đồng ${uncancelledContract?.contractNumber} đang chạy`)
                //   }
                // } else {
                AppCustomDialogHelper.hide();
                let updateContractSuccess = true;
                const uncancelledContract = row?.contracts?.find(contract => contract?.status !== AgencyConstants.ContractStatus.CANCELLED);
                if (!!uncancelledContract) {
                  updateContractSuccess = await AgencyHelper.API.requestUpdateContract(uncancelledContract?.contractId, {
                    status: AgencyConstants.ContractStatus.CANCELLED,
                    cancelingReason: "Hủy đơn hàng",
                  });
                  if (!updateContractSuccess) {
                    ToastHelper.showError(`Cập nhật trạng thái hợp đồng không thành công`);
                  }
                }
                if (updateContractSuccess) {
                  const result = await AgencyHelper.API.requestUpdateSale(row?.saleId, {
                    status: AgencyConstants.SaleOrderStatus.CANCELLED,
                  });
                  if (result && _.isBoolean(result)) {
                    ToastHelper.showSuccess('Hủy đơn hàng thành công');
                    handleFilterChanged({ ...filter });
                  } else {
                    ToastHelper.showError('Hủy đơn hàng thất bại');
                  }
                }
                // }
              }}
            />,
            'md',
            false,
            true
          );
        },
      });
      if (
        (row?.status === AgencyConstants.SaleOrderStatus.ORDERED &&
          (!Utils.isValid(contract) ||
            [AgencyConstants.ContractStatus.CREATED, AgencyConstants.ContractStatus.CANCELLED].includes(
              contract?.status
            )))
        || row?.status === AgencyConstants.SaleOrderStatus.CANCELLED
      )
        actions.push({
          text: 'Xoá đơn hàng',
          iconElement: (
            <i
              className="fa-regular fa-trash-can"
              style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
            />
          ),
          click: () => {
            AppCustomDialogHelper.show(
              '',
              <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
                title="Xoá đơn hàng"
                contentEl={
                  <>
                    Bạn có chắc muốn xoá đơn hàng:{' '}
                    <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                      {row?.saleId}
                    </span>
                    ?
                  </>
                }
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onConfirm={async () => {
                  AppCustomDialogHelper.hide();
                  const result = await AgencyHelper.API.requestDeleteSale(row?.saleId);
                  if (result && _.isBoolean(result)) {
                    ToastHelper.showSuccess('Xoá đơn hàng thành công');
                    handleFilterChanged({ ...filter });
                  } else {
                    ToastHelper.showError(result || 'Xoá đơn hàng thất bại');
                  }
                }}
              />,
              'md',
              false,
              true
            );
          },
        });
    }
    return actions;
  };

  return (
    <div>
      {/* header */}

      {showFullUI && (
        <div className="d-flex justify-content-between align-items-center">
          {/* title */}
          <div className="d-flex flex-column align-items-start">
            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
              Lịch sử mua gói đầu tư HTKD
            </span>
            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
              Tổng số:{' '}
              <span style={{ color: AppColors.primary }}>
                {Utils.formatNumber(packageTransactionTotal)} giao dịch
              </span>
            </span>
          </div>

          {/* actions */}
        </div>
      )}

      <div className="w-100 d-flex align-items-end flex-wrap">
        {/* tim kiem */}
        <div className="col-lg-3 pl-0 py-2 pr-0 pr-xl-4 pr-lg-4">
          <label htmlFor="search-bar" className="mb-0 mr-2 font-weight-bolder">
            {t('search')}
          </label>
          <KTFormSearch
            name="search-bar"
            placeholder={t('Theo mã đơn hàng, người bán hàng/giới thiệu...')}
            value={filter.q}
            onSubmit={(text) => {
              handleFilterChanged({
                q: text,
                page: 0,
              });
            }}
          />
        </div>
        <div className="col-xl-7 col-lg-9 px-0">
          <FilterComponentList />
        </div>

        {/* bo loc */}
        <div className="py-2 pr-4">
          <DropdownFilterTable
            filterComponent={[
              <div className={`${'col-12 p-0'}`}>
                <KTFormSearch
                  name="search-bar"
                  placeholder={t('Theo mã đơn hàng, người bán hàng/giới thiệu...')}
                  value={filter.q}
                  onSubmit={(text) => {
                    setFilterDropdown({
                      ...filterDropdown,
                      q: text,
                    });
                  }}
                />
              </div>,
              <FilterComponentList
                isInDropdown={true}
                onChange={(filter) => {
                  setFilterDropdown({
                    ...filterDropdown,
                    ...filter,
                  });
                }}
              />,
            ]}
            resetDefaultTable={() => {
              const updateFilterDropdown = {
                ...filterDropdown,
                q: '',
                status: '',
                contractStatus: '',
                from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                to: moment().format('YYYY-MM-DD'),
                selectedValue: dateFilter.baMuoiNgayGanNhat,
              };
              setFilterDropdown(updateFilterDropdown);
              handleFilterChanged({
                q: '',
                status: '',
                contractStatus: '',
                from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                to: moment().format('YYYY-MM-DD'),
                selectedValue: dateFilter.baMuoiNgayGanNhat,
              });
            }}
            saveFilter={() => {
              handleFilterChanged({
                q: filterDropdown.q,
                status: filterDropdown.status,
                contractStatus: filterDropdown.contractStatus,
                from: filterDropdown.from,
                to: filterDropdown.to,
                selectedValue: filterDropdown.selectedValue,
              })
            }}
            isDefaultFilter={Utils.checkDefaultFilter(
              ['page', 'limit', 'from', 'to', 'selectedValue'],
              filter,
              dateFilter.baMuoiNgayGanNhat,
              true
            )}
            direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
          />
        </div>

        {/* them moi */}
        <div className='py-2'>
          {UIHelper.buildGreenButton(
            'Thêm đơn hàng',
            () => {
              if (!adminRole && !agencyRoleList?.includes('SALE')) {
                ToastHelper.showError('Chức năng này không khả dụng do NĐT chưa ký hợp đồng môi giới với nhà điều hành')
              } else {
                if (handleAddOrder) {
                  handleAddOrder();
                } else {
                  router.navigate(`add-order?group=${agencyId}`);
                }
              }
            },
            <i className="fa-regular fa-circle-plus" />
          )}
        </div>
      </div>

      {/* body */}
      <div className="mt-4">
        <KTTable
          columns={columns}
          items={packageTransactionList}
          selectableRows={false}
          striped={false}
          compactGrid={false}
          onClickedRow={() => { }}
          onSelectedRowsChanged={(rows) => { }}
          onDoubleClickedRow={(rows) => { }}
          hasActionColumn={true}
          noDataComponent={
            <EmptyView
              icon={imgEmptyNoData}
              title="Không có dữ liệu để hiển thị"
              text={
                <div className="text-center">
                  <span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>
                </div>
              }
            />
          }
        />
      </div>

      {/* phan trang */}
      {!_.isEmpty(packageTransactionList) && (
        <div className="mt-4">
          <KTPagination
            currentPage={filter.page + 1}
            rowCount={packageTransactionTotal}
            rowsPerPage={filter.limit}
            currentItemInPageCount={packageTransactionList.length}
            onChangePage={(newPage) => {
              const iNewPage = parseInt(newPage);
              Global.g_filterStaffList = {
                ...Global.g_filterStaffList,
                page: iNewPage - 1,
              };
              handleFilterChanged({
                page: iNewPage - 1,
              });
            }}
            onChangeRowsPerPage={(newRowsPerPage) => {
              const iNewRowsPerPage = parseInt(newRowsPerPage);
              Global.g_filterStaffList = {
                ...Global.g_filterStaffList,
                limit: iNewRowsPerPage,
                page: 0,
              };
              handleFilterChanged({
                limit: iNewRowsPerPage,
                page: 0,
              });
            }}
            loading={false}
            color={KTPaginationColor.success}
          />
        </div>
      )}
    </div>
  );
}

export default PackageTransactionView;
